import apiClient from '../apiClient';
import { GET_RESTAURANT_ITEM_BY_ID_URL } from '../apiUrl';

const getRestaurantItemByIdApi = id => {
  return apiClient.get(GET_RESTAURANT_ITEM_BY_ID_URL(id));
};

export default getRestaurantItemByIdApi;
